import * as helpers from '../helpers';
import Message from './validators/components/message';
import PassportDirectory from './passport-directory';

export default class PassSport {
    constructor(selector = '.qwe') {
        this.selector = selector;

        // Plugin options
        this.options = {};

        // Needs for Passport destroy
        this.instancesToDestroy = [];
        this.eventsToRemoveListeners = [];
        this.ajDisciplines = [];

        this.init();
    }

    async init() {
        this.passportDirectory = await PassportDirectory.create();
        this.manageFirstDisciplineField();
        this.initCopyBlockEvents();
        this.ajaxI();
        this.ajaxS();
        this.initAjaxSelectFill();
        this.showHideBlock();
    }

    /**
     * Because BE cannot do this
     */
    manageFirstDisciplineField() {
        const firstDiscipline = document.querySelector('[data-ajs-discipline-url]');

        if (!firstDiscipline) {
            return;
        }

        const disciplineLabel = firstDiscipline.parentElement.querySelector('label');

        if (firstDiscipline.getAttribute('required')) {
            disciplineLabel.innerHTML = 'DISCIPLINE <em class="required">(obligatoire)</em>';
        }
    }

    /**
     * Init ajax on discipline, commune, clubs and federation fields
     */
    ajaxS() {
        const ajDisciplines = [...document.querySelectorAll(':not(.init)[data-ajs-discipline-url]')];
        this.ajDisciplines = [...this.ajDisciplines, ...ajDisciplines];

        ajDisciplines.forEach((ajDiscipline) => {
            ajDiscipline.classList.add('init');

            const ajCommune = document.querySelector(':not(.init)[data-ajs-commune-url]');
            const ajClub = document.querySelector(':not(.init)[data-ajs-club-url]');
            const ajFederation = document.querySelector(':not(.init)[data-ajs-federation-url]');

            // Get default values
            let defaultValueDiscipline = ajDiscipline.value || '';
            let defaultValueCommune = ajCommune && ajCommune.value ? ajCommune.value : '';
            let defaultValueClub = ajClub && ajClub.value ? ajClub.value : '';
            let defaultValueFederation = ajFederation && ajFederation.value ? ajFederation.value : '';

            this.ajCommune = ajCommune;
            this.ajClub = ajClub;
            this.ajFederation = ajFederation;

            this.hideAjaxS(ajCommune, ajClub, ajFederation);

            if (ajDiscipline) {
                this.fillSelect(ajDiscipline, this.passportDirectory.getDisciplines());

                ajDiscipline.value = defaultValueDiscipline;

                // Set default value for choice
                if (defaultValueDiscipline) {
                    ajDiscipline.setAttribute('data-choice-value', defaultValueDiscipline);
                }

                const scope = helpers.findAncestor(ajDiscipline, 'form-group') || ajDiscipline.form;

                const changeHandler = function _() {
                    this.hideAjaxS(ajCommune, ajClub, ajFederation);
                    this.addDependencyToDisciplines(scope, ajDiscipline.value, ajDiscipline.getAttribute('id'), ajDiscipline.getAttribute('data-prev-value'));

                    if (ajCommune) {
                        const communesArray = this.passportDirectory.getCommunes(ajDiscipline.value);
                        this.fillSelect(ajCommune, communesArray, this.setDefaultValueToDynamicSelect.bind(this, ajCommune));

                        if (defaultValueCommune) {
                            ajCommune.value = defaultValueCommune;
                        }
                    }

                    ajDiscipline.setAttribute('data-prev-value', ajDiscipline.value);
                };

                const $changeHandler = changeHandler.bind(this);

                if (defaultValueDiscipline) {
                    $changeHandler();
                    defaultValueDiscipline = '';
                }

                ajDiscipline.addEventListener('change', $changeHandler);

                this.eventsToRemoveListeners.push({ el: ajDiscipline, event: 'change', handler: $changeHandler });
            }

            if (ajCommune) {
                const changeHandler = function _() {
                    this.hideAjaxS(null, ajClub, ajFederation);

                    if (ajClub) {
                        const clubsArray = this.passportDirectory.getClubs(ajDiscipline.value, ajCommune.value);
                        this.fillSelect(ajClub, clubsArray, this.setDefaultValueToDynamicSelect.bind(this, ajClub));

                        if (defaultValueClub) {
                            ajClub.value = defaultValueClub;
                        }
                    }
                };

                const $changeHandler = changeHandler.bind(this);

                if (defaultValueCommune) {
                    $changeHandler();
                    defaultValueCommune = '';
                }

                ajCommune.addEventListener('change', $changeHandler);

                this.eventsToRemoveListeners.push({ el: ajCommune, event: 'change', handler: $changeHandler });
            }

            if (ajClub) {
                const form = ajDiscipline.form;

                const changeHandler = function _() {
                    this.hideAjaxS(null, null, ajFederation);

                    // const activeDisciplines = [...document.querySelectorAll('[data-ajs-discipline-url]')]
                    //     .filter((discipline) => { return !helpers.hasClass(discipline.parentElement, 'is-hidden'); });
                    //
                    // if (activeDisciplines.length >= 6) {
                    //     const message = Message.createMessage('Vous avez atteint le nombre maximum de 6 demandes pour une même famille.'
                    //     + ' Merci de bien vouloir contacter les services du Conseil départemental de l’Oise via le courriel suivant pass-sports@oise.fr',
                    //     'discipline-limit-info',
                    //     'info');
                    //
                    //     const messageExist = document.querySelector('#discipline-limit-info');
                    //
                    //     if (messageExist) {
                    //         messageExist.parentElement.removeChild(messageExist);
                    //     }
                    //
                    //     form.insertBefore(message, form.firstElementChild);
                    //     message.scrollIntoView({
                    //         block: 'center',
                    //         behavior: 'smooth',
                    //     });
                    // }

                    if (ajFederation) {
                        const ajFederationName = ajFederation.getAttribute('name');
                        const hiddenInput = document.createElement('input');

                        const federationsArray = this.passportDirectory.getFederations(ajClub.value);
                        this.fillSelect(ajFederation, federationsArray, this.setDefaultValueToDynamicSelect.bind(this, ajFederation), false);

                        if (ajFederation.options.length < 1) {
                            helpers.insertAfter(hiddenInput, ajFederation);
                            ajFederation.removeAttribute('name');
                            hiddenInput.setAttribute('type', 'hidden');
                            hiddenInput.setAttribute('name', ajFederationName);
                            hiddenInput.value = ajFederation.value;
                            ajFederation.setAttribute('disabled', 'disabled');
                        }

                        if (defaultValueFederation) {
                            ajFederation.value = defaultValueFederation;
                            defaultValueFederation = '';
                        }
                    }
                };

                const $changeHandler = changeHandler.bind(this);

                if (defaultValueClub) {
                    $changeHandler();
                    defaultValueClub = '';
                }

                ajClub.addEventListener('change', $changeHandler);

                this.eventsToRemoveListeners.push({ el: ajClub, event: 'change', handler: $changeHandler });
            }
        });
    }

    /**
     * After zip code change - give communes associated with this code and fill select
     */
    initAjaxSelectFill() {
        const selectFillInputArray = [...document.querySelectorAll('.js-fill-select')];

        selectFillInputArray.forEach((input) => {
            const target = document.querySelector(input.getAttribute('data-target'));

            if (!target) {
                console.error('Could not find fill select target');
                return;
            }

            let targetDefaultValue = target.value;

            target.setAttribute('disabled', 'disabled');

            const doRequest = (event) => {
                let value = input.value;

                if (event) {
                    value = event.target.value;
                }

                const disable = () => {
                    target.setAttribute('disabled', 'disabled');
                    const firstOption = target.options[0];
                    target.innerHTML = '';
                    target.appendChild(firstOption);
                };

                if (value.length === 5) {
                    // const res = await fetch(`${url}${value}`);
                    // const json = await res.json();
                    const communesArray = this.passportDirectory.getCommunesByZipCode(value);

                    if (communesArray.length) {
                        target.removeAttribute('disabled');
                        this.fillSelect(target, communesArray);

                        if (targetDefaultValue) {
                            target.value = targetDefaultValue;
                            targetDefaultValue = null;
                        }
                    } else {
                        disable();
                    }
                } else {
                    disable();
                }
            };

            doRequest();

            const $doRequest = doRequest.bind(this);

            input.addEventListener('input', $doRequest);

            this.eventsToRemoveListeners.push({ el: input, event: 'input', handler: $doRequest });
        });
    }

    /**
     * Check if all fields is have some value
     */
    validateAjiPassportFullness() {
        const passportsFields = [...document.querySelectorAll('[data-aji-passport]')];

        return !passportsFields.some(field => !field.value);
    }

    /**
     * Init events on copy and remove blocks button (BE extentions)
     * Clubs form
     */
    initCopyBlockEvents() {
        const copyBtn = document.querySelector('[data-copy-button]');
        const removeBtnArray = [...document.querySelectorAll('[data-remove-button]')];

        if (copyBtn && !helpers.hasClass(copyBtn, 'is-initialized')) {
            helpers.addClass(copyBtn, 'is-initialized');

            const handleClick = function _() {
                setTimeout(() => {
                    this.initCopyBlockEvents();
                    this.ajaxI();
                }, 500);
            };

            const $handleClick = handleClick.bind(this);

            copyBtn.addEventListener('click', $handleClick);

            this.eventsToRemoveListeners.push({ el: copyBtn, event: 'click', handler: $handleClick });
        }

        removeBtnArray.forEach((removeBtn) => {
            const submitBtn = removeBtn.form.querySelector('[type="submit"]');

            const handleClick = function _() {
                setTimeout(() => {
                    const isErrorExist = document.querySelector('.is-error');
                    const isAllPassportFieldFilled = this.validateAjiPassportFullness();

                    if (!isErrorExist && isAllPassportFieldFilled) {
                        submitBtn.removeAttribute('disabled');
                    }
                }, 400);
            };

            const $handleClick = handleClick.bind(this);

            removeBtn.addEventListener('click', $handleClick);

            this.eventsToRemoveListeners.push({ el: removeBtn, event: 'click', handler: $handleClick });
        });
    }

    /**
     * Init clubs passport fields handler
     */
    ajaxI() {
        const ajPasswords = [...document.querySelectorAll('[data-aji-passport]')];

        ajPasswords.forEach((ajPassword) => {
            const ajPasswordId = ajPassword.getAttribute('id');
            const form = ajPassword.form;
            const ajSubmit = form.querySelector(':not(.btn-cancel)[type="submit"]');

            const manageButtonDisabled = () => {
                const isErrorExist = document.querySelector('.is-error');

                if (!isErrorExist) {
                    ajSubmit.removeAttribute('disabled', 'disabled');
                }
            };

            manageButtonDisabled();

            if (helpers.hasClass(ajPassword, `is-initialized-${ajPasswordId}`)) {
                return;
            }

            helpers.addClass(ajPassword, `is-initialized-${ajPasswordId}`);

            const ajBtn = ajPassword.parentElement.querySelector('[data-aji-btn]');
            const messageId = `message-${ajPassword.getAttribute('id')}`;
            const messageText = ajPassword.getAttribute('data-message-text');
            const defaultMessageText = 'Vous avez déjà effectué une demande pour ce numéro de PassSport';
            const lastNameField = ajPassword.parentElement.parentElement.parentElement.querySelector('.js-passport-last-name');
            const nameField = ajPassword.parentElement.parentElement.parentElement.querySelector('.js-passport-name');

            if (lastNameField) {
                lastNameField.value = '';
                lastNameField.parentElement.style.display = 'none';
            }

            if (nameField) {
                nameField.value = '';
                nameField.parentElement.style.display = 'none';
            }

            helpers.addClass(ajBtn, 'is-hidden-i');
            ajSubmit.setAttribute('disabled', 'disabled');

            const checkValueLength = function _() {
                if (ajPassword.value.length > 0) {
                    helpers.removeClass(ajBtn, 'is-hidden-i');
                    ajBtn.removeAttribute('disabled', 'disabled');
                } else {
                    helpers.addClass(ajBtn, 'is-hidden-i');
                    ajBtn.setAttribute('disabled', 'disabled');
                }
            };

            const $checkValueLength = checkValueLength.bind(this);

            ajPassword.addEventListener('input', $checkValueLength);

            this.eventsToRemoveListeners.push({ el: ajPassword, event: 'input', handler: $checkValueLength });

            checkValueLength();

            const handleClick = async function _() {
                if (!ajPassword.value) {
                    return;
                }

                const url = ajPassword.getAttribute('data-aji-passport');
                const data = await this.getData(`${url}${ajPassword.value}`);
                const isFieldWithSameValueExist = ajPasswords.some((passportField) => {
                    return passportField.getAttribute('id') !== ajPassword.getAttribute('id')
                        && passportField.value === ajPassword.value;
                });

                ajSubmit.setAttribute('disabled', 'disabled');

                if (data && !data.error && !isFieldWithSameValueExist) {
                    helpers.removeClass(ajPassword, 'is-error');

                    manageButtonDisabled();

                    if (lastNameField) {
                        lastNameField.parentElement.style.display = 'block';
                        lastNameField.value = data.lastName;
                        lastNameField.setAttribute('readonly', 'readonly');
                    }

                    if (nameField) {
                        nameField.parentElement.style.display = 'block';
                        nameField.value = data.firstName;
                        nameField.setAttribute('readonly', 'readonly');
                    }

                    Message.removeErrorFromBlock(messageId);
                } else {
                    helpers.addClass(ajPassword, 'is-error');
                    helpers.addClass(ajBtn, 'is-hidden-i');
                    ajBtn.setAttribute('disabled', 'disabled');

                    Message.addErrorToBlock(messageText || data.error || defaultMessageText, messageId, ajPassword.parentElement.parentElement.parentElement);
                }
            };

            const $handleClick = handleClick.bind(this);

            ajBtn.addEventListener('click', $handleClick);

            this.eventsToRemoveListeners.push({ el: ajBtn, event: 'click', handler: $handleClick });

            ajBtn.dispatchEvent(helpers.createEvent('click'));
        });
    }

    async getData(url) {
        const fe = window.location.hostname === 'localhost' || window.location.hostname === 'integration.stratis.fr';

        if (fe) {
            return new Promise((resolve, _) => {
                setTimeout(() => {
                    resolve(
                        {
                            250: {
                                id: 1,
                                title: 'Test 1',
                            },
                            300: {
                                id: 2,
                                title: 'Test 2',
                            },
                            400: {
                                id: 3,
                                title: 'Test 3',
                            },
                            500: {
                                id: 4,
                                title: 'Test 4',
                            },
                            600: {
                                id: 5,
                                title: 'Test 5',
                            },
                            error: 'Vous avez déjà effectué une demande pour ce numéro de PassSport (Test on dev)',
                        },
                    );
                }, 500);
            });
        }

        try {
            const response = await fetch(`${url}`, {
                method: 'GET',
            });

            if (response.status >= 200 && response.status < 300) {
                // If status OK return JSON
                return await response.json();
            }
        } catch (error) {
            console.warn('data not found.');
            console.warn(error);
        }
    }

    fillSelect(select, dataObject, cb = () => {}, enableFirstOption = true) {
        let data = [];

        data = Array.isArray(dataObject) ? dataObject : Object.values(dataObject);

        if (data && data.length) {
            const firstOption = select.children[0];
            select.innerHTML = '';

            if (enableFirstOption) {
                select.appendChild(firstOption);
            }

            data.forEach((item) => {
                const option = new Option(item.title, item.id);
                select.appendChild(option);
            });

            helpers.removeClass(select.parentElement, 'is-hidden-s');

            if (select.getAttribute('data-required')) {
                helpers.makeBlockRequired(select);
            }
        }

        cb(data);
    }

    hideAjaxS(ajCommune, ajClub, ajFederation) {
        if (ajCommune) {
            helpers.addClass(ajCommune.parentElement, 'is-hidden-s');
            ajCommune.classList.add('init');
            helpers.makeBlockUnRequired(ajCommune);
        }

        if (ajClub) {
            helpers.addClass(ajClub.parentElement, 'is-hidden-s');
            ajClub.classList.add('init');
            helpers.makeBlockUnRequired(ajClub);
        }

        if (ajFederation) {
            helpers.addClass(ajFederation.parentElement, 'is-hidden-s');
            ajFederation.classList.add('init');
            helpers.makeBlockUnRequired(ajFederation);
        }
    }

    /**
     * When option is chosen - disable other same options in other disciplines
     * @param {*} scope - query selector scope
     * @param {*} valueToRemove - target options value
     * @param {*} targetId - main select id
     * @param {*} prevValue - previous select value (needs for undisabling)
     */
    addDependencyToDisciplines(scope, valueToRemove, targetId, prevValue) {
        const ajDisciplines = [...scope.querySelectorAll('[data-ajs-discipline-url]')]
            .filter((item) => { return item.getAttribute('id') !== targetId; });

        ajDisciplines.forEach((ajDiscipline) => {
            if (valueToRemove !== 0 && valueToRemove !== '') {
                const optionToDisable = ajDiscipline.querySelector(`[value="${valueToRemove}"]`);

                if (optionToDisable) {
                    optionToDisable.setAttribute('disabled', true);
                }
            }

            if (!prevValue) {
                return;
            }

            ajDisciplines.forEach((discipline) => {
                const optionsToEnable = discipline.querySelector(`[value="${prevValue}"]`);

                if (optionsToEnable) {
                    optionsToEnable.removeAttribute('disabled', true);
                }
            });
        });
    }

    /**
     * Set value from attribute to select
     * @param {HTMLElement} select - target select element
     */
    setDefaultValueToDynamicSelect(select) {
        const defaultValue = select.getAttribute('data-value');
        const isDefaultValueSetted = helpers.hasClass(select, 'is-default-value-setted');

        if (!defaultValue || isDefaultValueSetted) {
            return;
        }

        setTimeout(() => {
            select.value = defaultValue;
            select.dispatchEvent(helpers.createEvent('change'));
            helpers.addClass([select], 'is-default-value-setted');
        }, 500);
    }

    clearInputValuesInsideBlock(block) {
        const inputsToClear = [...block.querySelectorAll('input, select, textarea')];

        inputsToClear.forEach((field) => {
            if (field.getAttribute('type') === 'hidden') {
                return;
            }

            if (field.nodeName === 'SELECT') {
                field.selectedIndex = 0;
            } else if (field.getAttribute('type') === 'radio' || field.getAttribute('type') === 'checkbox') {
                field.checked = false;
            } else {
                field.value = '';
            }

            field.dispatchEvent(helpers.createEvent('change'));
            field.dispatchEvent(helpers.createEvent('blur'));
        });
    }

    showHideBlock() {
        const allShBlocks = [...document.querySelectorAll('[data-sh-block]')];
        allShBlocks.forEach((block) => {
            if (block.hasAttribute('data-sh-block')) {
                let blockIsEmpty = true;
                const attr = block.getAttribute('data-sh-block');

                const fields = [...block.querySelectorAll('input, select')];

                fields.forEach((field) => {
                    if (field.value !== '' && field.value !== 0 && field.value !== '0' && field.value !== 'Y-m-d') {
                        blockIsEmpty = false;
                    }
                });

                if (attr !== 'visible' && blockIsEmpty) {
                    helpers.addClass(block, 'is-hidden');
                    helpers.makeBlockUnRequired(block);
                } else {
                    helpers.removeClass(block, 'is-hidden');
                }
            }
        });

        const closeBtnArray = [...document.querySelectorAll('[data-sh-btn-close]')];
        closeBtnArray.forEach((btn) => {
            if (helpers.hasClass(btn, 'js-hide-close-button')) {
                btn.style.display = 'none';
            }

            if (btn.hasAttribute('data-sh-btn-close')) {
                const handleClick = function _() {
                    const closeBtnAttr = btn.getAttribute('data-sh-btn-close');
                    const parents = [...document.querySelectorAll(`[data-sh-block="${closeBtnAttr}"]`)];
                    const infoMessage = document.querySelector('#discipline-limit-info');

                    if (infoMessage) {
                        infoMessage.parentElement.removeChild(infoMessage);
                    }

                    if (helpers.hasClass(btn, 'js-hide-close-button')) {
                        btn.style.display = 'none';
                    }

                    parents.forEach((parent) => {
                        const closeButtonsInsideParent = [...parent.querySelectorAll('[data-sh-btn-close]')];

                        closeButtonsInsideParent.forEach((button) => {
                            button.click();
                        });

                        helpers.addClass(parent, 'is-hidden');
                        helpers.makeBlockUnRequired(parent);
                        this.clearInputValuesInsideBlock(parent);
                    });

                    const reg = closeBtnAttr.match(/sh(\/|-|\.)([0-9]*)/gm).join('');

                    if (reg) {
                        const btnClose = document.querySelector(`[data-sh-btn="${reg}"]`);
                        if (btnClose) {
                            btnClose.removeAttribute('disabled');
                        }

                        if (parents && parents[0]) {
                            const isFieldset = parents[0].querySelector('legend');

                            if (!isFieldset) {
                                const targetFieldset = helpers.findAncestor(btn, 'form-group');
                                const firstDiscipline = targetFieldset.querySelector('[data-ajs-discipline-url]');
                                const disciplineLabel = firstDiscipline.parentElement.querySelector('label');
                                const isRequired = firstDiscipline.getAttribute('required');

                                if (isRequired) {
                                    disciplineLabel.innerHTML = 'DISCIPLINE <em class="required">(obligatoire)</em>';
                                } else {
                                    disciplineLabel.innerText = 'DISCIPLINE';
                                }
                            }
                        }
                    }
                };

                const $handleClick = handleClick.bind(this);

                btn.addEventListener('click', $handleClick);

                this.eventsToRemoveListeners.push({ el: btn, event: 'click', handler: $handleClick });
            }
        });

        const shBtns = [...document.querySelectorAll('[data-sh-btn^="sh-"]')];

        shBtns.forEach((btn) => {
            const btnAttr = btn.getAttribute('data-sh-btn');
            const closeBtn = document.querySelector(`[data-sh-btn-close="${btnAttr}-1"]`);

            const handleClick = function _() {
                if (!btnAttr) {
                    return;
                }

                const firstFieldset = document.querySelector('.js-child-validation');
                const legendText = firstFieldset.querySelector('legend').firstElementChild;
                const firstBlock = document.querySelector(`.is-hidden[data-sh-block^="${btnAttr}-"]`);

                if (firstBlock) {
                    const firstFocusableEl = helpers.getFirstFocusableElement(firstBlock);
                    const firstAttr = firstBlock.getAttribute('data-sh-block');
                    const shBlocks = [...document.querySelectorAll(`.is-hidden[data-sh-block="${firstAttr}"]`)];
                    const blockIsFieldset = firstBlock.querySelector('legend');

                    if (closeBtn && closeBtn.style.display === 'none') {
                        closeBtn.style.display = 'block';
                    }

                    if (blockIsFieldset) {
                        legendText.innerText = 'Enfant 1';
                    } else {
                        const targetFieldset = helpers.findAncestor(btn, 'form-group');
                        const firstDiscipline = targetFieldset.querySelector('[data-ajs-discipline-url]');
                        const disciplineLabel = firstDiscipline.parentElement.querySelector('label');
                        const isRequired = firstDiscipline.getAttribute('required');

                        if (isRequired) {
                            disciplineLabel.innerHTML = 'DISCIPLINE 1 <em class="required">(obligatoire)</em>';
                        } else {
                            disciplineLabel.innerText = 'DISCIPLINE 1';
                        }
                    }

                    shBlocks.forEach((bl) => {
                        helpers.removeClass(bl, 'is-hidden');
                        helpers.makeBlockRequired(bl);
                    });


                    firstBlock.scrollIntoView({
                        block: 'center',
                        behavior: 'smooth',
                    });

                    if (firstFocusableEl) {
                        setTimeout(() => {
                            firstFocusableEl.focus();
                        }, 700);
                    }
                }

                const shBlock = [...document.querySelectorAll(`.is-hidden[data-sh-block^="${btnAttr}-"]`)];

                if (shBlock.length === 0) {
                    btn.setAttribute('disabled', 'disabled');
                }
            };

            const $handleClick = handleClick.bind(this);

            btn.addEventListener('click', $handleClick);

            this.eventsToRemoveListeners.push({ el: btn, event: 'click', handler: $handleClick });

            const shBlock = [...document.querySelectorAll(`.is-hidden[data-sh-block^="${btnAttr}-"]`)];

            if (shBlock.length === 0) {
                btn.setAttribute('disabled', 'disabled');
            }
        });
    }

    updateDisabledOptionsInsideDiscipline() {
        this.ajDisciplines.forEach((el, index) => {
            if (!document.querySelector(`#${el.getAttribute('id')}`)) {
                this.ajDisciplines.splice(index, 1);
                return;
            }

            const scope = helpers.findAncestor(el, 'form-group') || el.form;
            const disabledOptions = [...el.querySelectorAll('option[disabled]')];

            disabledOptions.forEach((disabledOption) => {
                const value = disabledOption.getAttribute('value');
                const isNotDisabledOptionExist = [...scope.querySelectorAll(`option[value="${value}"]`)]
                    .some(findedOption => !findedOption.getAttribute('disabled'));

                if (!isNotDisabledOptionExist) {
                    disabledOption.removeAttribute('disabled');
                }
            });

            this.addDependencyToDisciplines(scope, el.value, el.getAttribute('id'));
        });
    }

    async update() {
        await this.init();
        this.updateDisabledOptionsInsideDiscipline();
    }
}
